import { createContext, useContext, useEffect, useReducer } from "react";
import SurveySectionReducer from "./LongSurveyReducer";

const INITIAL_SECTION_STATE = {
	longSurveySection: JSON.parse(
		sessionStorage.getItem("longSurveySection") || "null"
	),
};

export const SurveySectionContext = createContext({
	longSurveySection: INITIAL_SECTION_STATE.longSurveySection,
	dispatch: () => null,
});

export const LongSurveyProvider = ({ children }) => {
	const [state, dispatch] = useReducer(
		SurveySectionReducer,
		INITIAL_SECTION_STATE
	);

	useEffect(() => {
		if (state.longSurveySection) {
			sessionStorage.setItem(
				"longSurveySection",
				JSON.stringify(state.longSurveySection)
			);
		}
	}, [state.longSurveySection]);

	return (
		<SurveySectionContext.Provider
			value={{
				longSurveySection: state.longSurveySection,
				dispatch,
			}}
		>
			{children}
		</SurveySectionContext.Provider>
	);
};

export const useLongSurveyContent = () => {
	const context = useContext(SurveySectionContext);
	if (!context) {
		throw new Error(
			"useLongSurveyContent must be used within a LongSurveyProvider"
		);
	}
	return context;
};
